



















































































































































































































































































































































import { Category } from '@/types/categories';

import Vue from 'vue';
import _ from 'lodash';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter, Mutation, State } from 'vuex-class';
import ContentPreview from '@/components/Editor/ContentPreview.vue';
import store from '@/store';
import { EditorState } from '@/types/editor';
import { codemirror } from 'vue-codemirror-lite';
require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/addon/edit/closetag');
require('codemirror/addon/edit/matchtags');
import { Image as ImageType } from '@/types/image';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import HistoryManager from '@/components/Editor/HistoryManager.vue';
import AddRedirectDialog from '@/components/Editor/AddRedirectDialog.vue';
import FeaturedImage from '@/components/Editor/FeaturedImage.vue';
import TwitterPreview from '@/components/Editor/TwitterPreview.vue';
import LinkedInPreview from '@/components/Editor/LinkedInPreview.vue';
import FacebookPreview from '@/components/Editor/FacebookPreview.vue';
import MetaDataInput from '@/components/Editor/MetaDataInput.vue';
import ImageGalleryModal from '@/components/Editor/ImageGalleryModal.vue';
import Editor from '@/components/Editor/Editor.vue';
import CarouselManager from '@/components/Editor/CarouselManager.vue';
import { Author } from '@/types/author';
import moment from 'moment';

@Component({
  components: {
    Editor,
    ImageGalleryModal,
    AddRedirectDialog,
    ConfirmationDialog,
    FeaturedImage,
    HistoryManager,
    ContentPreview,
    codemirror,
    TwitterPreview,
    LinkedInPreview,
    FacebookPreview,
    MetaDataInput,
    CarouselManager,
  },
})
export default class ContentEditor extends Vue {
  @Prop() id!: string;
  @Action('authors/getAuthorList') getAuthorList!: Function;
  @Action('editor/deleteContent') deleteContent!: Function;
  @Action('editor/getContent') getContent!: Function;
  @Action('editor/publishContent') publishContent!: Function;
  @Action('editor/unpublishContent') unpublishContent!: Function;
  @Action('editor/saveContent') saveContent!: Function;
  @Action('notifications/error') showError!: Function;
  @Action('notifications/success') showSuccess!: Function;
  @Getter('authors/authors') authors!: Author[];
  @Getter('categories/category') category!: Category;
  @Getter('categories/categories') categories!: Category[];
  @State('editor') content!: EditorState;
  @Mutation('editor/setTitle') setTitle!: Function;
  @Mutation('editor/setBody') setBody!: Function;
  @Mutation('editor/setContent') setContent!: Function;
  @Mutation('editor/setImage') setImage!: Function;

  confirmDeleteDialog: boolean = false;
  confirmUnpublishDialog: boolean = false;
  dialog: boolean = false;
  dateMenu: boolean = false;
  isDirty: boolean = false;
  tabs: number = 0;
  toggleEditMode: number = 0;
  codemirrorOptions: object = {
    mode: 'htmlmixed',
    tabSize: 4,
    lineNumbers: true,
    lineWrapping: true,
    matchTags: true,
    closeTag: true,
    viewportMargin: Infinity,
  };

  validation: object = {
    title: [(v: any) => !!v || 'A title is required'],
    slug: [(v: any) => !!v || 'A slug is required'],
    category: [(v: any) => !!v || 'A category is required'],
    summary: [(v: any) => !!v || 'A summary is required'],
  };

  isEditorValid: boolean = true;
  isPublishing: boolean = false;
  isSaving: boolean = false;

  currentCommit: string = 'latest';

  get contentUrl() {
    if (this.content.category_id && this.category) {
      return `/${this.category.meta!.slug}/${this.content.meta!.slug}`;
    }
    return '';
  }

  get title() {
    return this.content.meta!.title !== undefined
      ? this.content.meta!.title
      : '';
  }

  set title(value) {
    this.setTitle(value);
    this.content.meta!.slug = _.kebabCase(value);
  }

  get prettyPublishedDate() {
    return this.content.published_at === null
      ? null
      : moment(this.content.published_at).format('DD/MM/YYYY');
  }

  get pageName() {
    return this.content.meta !== null
      ? this.content.meta!.title
      : 'Add new article';
  }

  get titleProgress(): number {
    return Math.min(100, Math.floor(this.title.length * 0.6));
  }

  get titleColour(): string {
    if (this.title.length > 100) {
      return 'error';
    }
    const index = Math.min(2, Math.floor(this.title.length / 30));
    return ['error', 'warning', 'success'][index];
  }

  get isPublished(): boolean {
    if (this.content.meta !== null) {
      return this.content.meta!.live_commit !== null;
    }
    return false;
  }

  get isSaved(): boolean {
    return this.content.created_at !== undefined;
  }

  get contentCategory(): Category {
    return this.category;
  }

  get editorContent(): string {
    return this.content.content as string;
  }

  set editorContent(value) {
    this.setBody(value);
  }

  get nestedCategories(): Category[] {
    const allCategories: Category[] = [];
    this.categories.forEach(c => {
      allCategories.push(c);
      if (c.children) {
        c.children.forEach(child => allCategories.push(child));
      }
    });

    return allCategories;
  }

  async saveDraft() {
    this.isSaving = true;

    if (!this.formIsValid()) {
      this.showError('You must complete all required fields');
      this.isSaving = false;
      return;
    }

    try {
      await this.saveContent();
      this.isDirty = false;
      this.showSuccess('Draft saved');
    } catch (e) {
      this.showError(
        'There was an error trying to save the draft. Check for invalid fields',
      );
    }

    this.isSaving = false;
  }

  updateFeaturedImage(image: ImageType) {
    this.setImage(image);
  }

  onDelete(redirect?: string) {
    this.deleteContent({ id: this.content.id, redirect });
    this.$router.push({ name: 'editor-new' });
  }

  onEditorBlur() {
    return (this.isEditorValid =
      this.editorContent !== '<p>&nbsp;</p>' && !!this.editorContent);
  }

  async onPublish() {
    this.isPublishing = true;
    await this.publishContent(this.content.id);
    this.showSuccess('Content published');
    this.isPublishing = false;
  }

  onUnpublish(redirect?: string) {
    this.unpublishContent({ id: this.content.id, redirect });
  }

  async onRevisionChange(commitHash: string) {
    await this.getContent({ id: this.content.id, commitHash });
    this.isDirty = false;
    this.currentCommit = commitHash;
  }

  formIsValid(): boolean {
    return [
      (<HTMLFormElement>this.$refs.title).validate(true),
      this.onEditorBlur(),
      (<HTMLFormElement>this.$refs.category).validate(true),
      (<HTMLFormElement>this.$refs.summary).validate(true),
      (<HTMLFormElement>this.$refs.featuredImage).validate(true),
    ].every(v => v);
  }

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    store.dispatch('authors/getAuthorList');
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('editor/getContent', { id: to.params.id });
    }
    next();
  }

  async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: Function,
  ): Promise<void> {
    if (to.params.hasOwnProperty('id')) {
      await store.dispatch('editor/getContent', { id: to.params.id });
      this.currentCommit = 'latest';
    }
    next();
  }

  @Watch('dialog')
  async onDialogChanged(val: Boolean) {
    if (val && this.isDirty) {
      await this.saveDraft();
    }
  }

  @Watch('content.id')
  onContentIdChanged(id?: string, oldId?: string) {
    if (id && oldId === undefined) {
      this.$router.replace({ name: 'editor', params: { id } });
    }
  }

  @Watch('content', { deep: true })
  onContentChanged() {
    this.isDirty = true;
  }
}
